import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { LIGHT_THEME, Theme, ThemeService } from "@tylertech/cj-jpp-ui-core/theme";
import { AuthenticationService } from "@tylertech/cj-jpp-ui-core/authentication";
import { Subscription } from "rxjs/internal/Subscription";
import { Instance } from "@tylertech/cj-jpp-tims-angular-sdk/model/instance";
import { combineLatestWith, firstValueFrom, map, Observable, shareReplay } from "rxjs";
import { ToastService } from "@tylertech/forge-angular";
import { UserService } from "../../core/services/user.service";
import { InstanceManagerService } from "../../core/services/instance-manager.service";
import { InstanceConfigService } from 'src/app/core/services/instance-config.service';

@Component({
  selector: 'app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss']
})
export class AppBarComponent implements OnInit, OnDestroy {
  @Output() menuBtnClicked: EventEmitter<void> = new EventEmitter<void>();

  protected activeInstanceId$: Observable<string> = this.instanceManagerService.instance$.pipe(
    map(i => i.instanceId),
    shareReplay(1));

  protected instances$: Observable<Instance[]> = this.instanceManagerService.instances$;

  protected activeInstanceName$: Observable<string | undefined> = this.activeInstanceId$.pipe(
    combineLatestWith(this.instances$),
    map(([instanceId, instances]) => {
      return instances.find(i => i.instanceId === instanceId)?.name;
    })
  );
  protected themeIcon: string | undefined;
  protected user$: Observable<any> = this.userService.user$;
  private subscriptions: Subscription[] = [];

  readonly siteTitle$ = this.instanceConfigService.siteTitle$
    .pipe(
      map((title) => title ? `| ${title}` : '')
    );
  protected logo$ = this.instanceConfigService.logo$;

  constructor(private authService: AuthenticationService,
              private instanceManagerService: InstanceManagerService,
              private themeService: ThemeService,
              private toastService: ToastService,
              protected userService: UserService,
              private instanceConfigService: InstanceConfigService
  ) {}

  ngOnInit(): void {
    this.configureThemeListener();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public async handelInstanceItemClick(instance: Instance) {
    try {
      await firstValueFrom(this.instanceManagerService.setActiveInstance(instance.instanceId || 'missing-instance-id'));
      location.reload();
    } catch (err) {
      console.error(err);
      const toast = this.toastService.show({
        message: `An error occurred changing instance`,
        actionHandler: () => toast.close(),
        placement: 'top',
        duration: 5000
      });
    }
  }

  public handleThemeButtonClick(): void {
    this.themeService.toggleTheme();
  }

  public async handleSignOutButtonCLick() {
    await this.authService.logOut();
  }

  private configureThemeListener() {
    this.subscriptions.push(
      this.themeService.theme.subscribe((theme: Theme) => {
        const body = document.body;

        if (theme === LIGHT_THEME) {
          this.themeIcon = 'brightness_3';
          body.classList.remove("dark-theme");
        } else {
          body.classList.add("dark-theme");
          this.themeIcon = 'wb_sunny';
        }
      })
    );
  }
}